module.exports = __webpack_public_path__ + "static/media/git.76d344f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/git.svg
// module id = 113
// module chunks = 0